/** Унифицированный текст с преднастроенными размерами. */
import { createElement, type ComponentPropsWithoutRef } from "react";

type TextSize = "small" | "medium" | "large" | "xl";
type TextElement = "p" | "small" | "span";

const sizes: Record<TextSize, string> = {
	small: "text-xs",
	medium: "text-sm leading-5",
	large: "text-sm font-semibold",
	xl: "text-2xl font-semibold",
};

type TextProps = ComponentPropsWithoutRef<TextElement> & {
	as?: TextElement;
	size?: TextSize;
};

export const Text = ({ as = "p", size = "medium", className = "", ...props }: TextProps) =>
	createElement(as, {
		className: `${as === "span" && size === "medium" ? "" : sizes[size]} ${className}`,
		...props,
	});
